import { Scanner } from "@yudiel/react-qr-scanner";

export default function QRScanner({ onError, onScan, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className={`absolute inset-0 bg-black/40 transition-opacity duration-200 opacity-100`} onClick={onClose} />

      <div
        className={`
          bg-backdrop text-white w-full md:w-[26rem] rounded-2xl shadow-xl p-3
          transform transition-all duration-200 sm:translate-x-0 md:translate-x-36 scale-100 opacity-100
        `}
      >
        <div className="mb-6">
          <Scanner
            onScan={onScan}
            onError={onError}
            components={{
              torch: true,
              zoom: true,
            }}
          />
        </div>
      </div>
    </div>
  );
}
